(function(){
  var d=document,root=d.documentElement;root.classList.add('sw-js');
  var rm=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  /* announcement bar */
  var bar=d.getElementById('sw-ann');
  if(bar){var s=bar.querySelectorAll('.sw-ann-s'),i=0,t;
    var show=function(n){i=(n+s.length)%s.length;s.forEach(function(x,k){x.classList.toggle('on',k===i)})};
    var play=function(){clearInterval(t);if(s.length>1&&!rm)t=setInterval(function(){show(i+1)},4000)};
    bar.querySelectorAll('.sw-ann-nav').forEach(function(b){b.addEventListener('click',function(){show(i+Number(b.dataset.d));play()})});
    play();}

  /* reveal on scroll */
  var els=d.querySelectorAll('.sw-rv,.sw-head');
  if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(el){io.observe(el)})}
  else els.forEach(function(el){el.classList.add('in')});

  /* hero video */
  var hv=d.querySelector('.hero video');
  if(hv){hv.muted=true;hv.setAttribute('playsinline','');if(rm){hv.removeAttribute('autoplay');hv.pause()}else{var p=hv.play();if(p&&p.catch)p.catch(function(){})}}

  /* tabs */
  d.querySelectorAll('[data-tabs]').forEach(function(w){
    var tabs=w.querySelectorAll('.sw-tab'),panels=w.querySelectorAll('.sw-panel');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      tabs.forEach(function(x){x.setAttribute('aria-selected',x===t)});
      panels.forEach(function(p){p.classList.toggle('on',p.dataset.panel===t.dataset.tab)});
    })});
  });

  /* search toggle */
  var sb=d.getElementById('sbar'),sbtn=d.getElementById('sbtn');
  if(sb&&sbtn)sbtn.addEventListener('click',function(){var o=sb.style.display==='none';sb.style.display=o?'flex':'none';sbtn.setAttribute('aria-expanded',o);if(o)sb.querySelector('input').focus()});

  /* toast */
  var toastEl=d.getElementById('toast'),tt;
  function toast(h){if(!toastEl)return;toastEl.innerHTML=h;toastEl.classList.add('on');clearTimeout(tt);tt=setTimeout(function(){toastEl.classList.remove('on')},3200)}

  function setCount(n){d.querySelectorAll('[data-cart-count]').forEach(function(c){c.textContent=n})}

  /* ajax add to cart */
  d.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches('form[data-ajax-cart]'))return;
    e.preventDefault();
    var b=f.querySelector('[type=submit][name=add]')||f.querySelector('[type=submit]'),label=b?b.textContent:'';
    if(b){b.disabled=true;b.textContent='Adding...'}
    fetch(R+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){return fetch(R+'cart.js').then(function(r){return r.json()})})
      .then(function(c){setCount(c.item_count);
        if(b){b.textContent='Added';b.classList.add('is-done')}
        toast('Added to cart <a href="'+R+'cart">View cart</a>');
        setTimeout(function(){if(b){b.textContent=label;b.classList.remove('is-done');b.disabled=false}},1800)})
      .catch(function(err){if(b){b.textContent=label;b.disabled=false}toast((err&&err.description)||'Could not add this item. Please try again.')});
  });

  /* product page */
  d.querySelectorAll('[data-product]').forEach(function(pd){
    var q=pd.querySelector('input[name=quantity]');
    pd.querySelectorAll('[data-q]').forEach(function(b){b.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value,10)||1)+Number(b.dataset.q))})});
    var main=pd.querySelector('.pd-main');
    pd.querySelectorAll('.pd-thumbs button').forEach(function(b){b.addEventListener('click',function(){
      if(main){main.src=b.dataset.src;main.removeAttribute('srcset');main.alt=b.dataset.alt||''}
      pd.querySelectorAll('.pd-thumbs button').forEach(function(x){x.setAttribute('aria-current',x===b)});
    })});
    var js=pd.querySelector('[data-variants]'),sel=pd.querySelector('select[name=id]');
    if(!js||!sel)return;
    var V=JSON.parse(js.textContent),money=pd.dataset.moneyFormat||'${{amount}}';
    function fmt(c){var a=(c/100).toFixed(2),p=a.split('.');var withC=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+p[1];
      return money.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){if(k==='amount_no_decimals')return p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');if(k==='amount_with_comma_separator')return p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+p[1];return withC})}
    sel.addEventListener('change',function(){
      var v=V.filter(function(x){return String(x.id)===sel.value})[0];if(!v)return;
      var pr=pd.querySelector('[data-price]'),cp=pd.querySelector('[data-compare]'),off=pd.querySelector('[data-off]'),btn=pd.querySelector('[name=add]');
      if(pr)pr.textContent=fmt(v.price);
      var sale=v.compare_at_price&&v.compare_at_price>v.price;
      if(cp){cp.textContent=sale?fmt(v.compare_at_price):'';cp.hidden=!sale}
      if(off){off.textContent=sale?'-'+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%':'';off.hidden=!sale}
      if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';btn.classList.toggle('is-out',!v.available)}
      if(v.featured_image&&main){main.src=v.featured_image;main.removeAttribute('srcset')}
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
    });
  });

  /* back to top */
  var tb=d.getElementById('totop');
  if(tb){var tf=function(){tb.classList.toggle('on',(window.scrollY||root.scrollTop)>600)};addEventListener('scroll',tf,{passive:true});tf();
    tb.addEventListener('click',function(){window.scrollTo({top:0,behavior:rm?'auto':'smooth'})})}
})();
/* mobile menu */
(function(){var m=document.getElementById('mnav'),b=document.getElementById('mbtn');if(!m||!b)return;
function open(){m.hidden=false;b.setAttribute('aria-expanded','true');document.body.classList.add('mnav-open');var c=m.querySelector('[data-close]');setTimeout(function(){m.querySelector('.mnav-top button').focus()},50)}
function close(){m.hidden=true;b.setAttribute('aria-expanded','false');document.body.classList.remove('mnav-open');b.focus()}
b.addEventListener('click',open);
m.addEventListener('click',function(e){if(e.target.closest('[data-close]')||e.target.closest('a'))close()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!m.hidden)close()});
addEventListener('resize',function(){if(innerWidth>860&&!m.hidden)close()});
})();
